import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HouseLine, SignOut } from "@phosphor-icons/react";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const navClass = ({ isActive }) =>
    `text-xs uppercase tracking-[0.15em] transition-colors duration-200 ${
      isActive ? "text-[#C49A6C]" : "text-[#A3A39C] hover:text-[#F4F4F0]"
    }`;

  return (
    <div className="min-h-screen bg-[#141413] text-[#F4F4F0]">
      <header data-testid="app-header" className="border-b border-[#2E2E2A] bg-[#141413]">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/dashboard" data-testid="app-logo" className="flex items-center gap-2">
            <HouseLine size={22} weight="duotone" className="text-[#C49A6C]" />
            <span className="font-heading text-xl tracking-tight">TTPI Academy</span>
          </Link>
          <nav className="flex items-center gap-6">
            <NavLink to="/dashboard" data-testid="nav-dashboard" className={navClass}>Modules</NavLink>
            <NavLink to="/bookings" data-testid="nav-bookings" className={navClass}>Sessions</NavLink>
            <NavLink to="/services" data-testid="nav-services" className={navClass}>Services</NavLink>
            {user?.role === "admin" && (
              <NavLink to="/admin" data-testid="nav-admin" className={navClass}>Admin</NavLink>
            )}
            <button
              data-testid="logout-button"
              onClick={handleLogout}
              className="flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-[#A3A39C] transition-colors duration-200 hover:text-[#F4F4F0]"
            >
              <SignOut size={16} /> Logout
            </button>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10">{children}</main>
    </div>
  );
}
